/**
 * Default-Date-Range: letzte 30 Tage (UTC).
 */
export interface DateRange {
  from: string;
  to: string;
}

function toIso(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function defaultRange(daysBack = 30): DateRange {
  const to = new Date();
  const from = new Date();
  from.setUTCDate(from.getUTCDate() - daysBack);
  return { from: toIso(from), to: toIso(to) };
}

export function rangeFromDates(from: Date, to: Date): DateRange {
  return { from: toIso(from), to: toIso(to) };
}
